const config = {
  iframe: process.env.IFRAME_APP_URL || 'https://docv-iframe.alloy.co/',
  codeless: process.env.CODELESS_SDK_APP_URL || 'https://alloysdk.alloy.co/'
};

export default config;
